import type { DatePeriodValues, SelectOption } from "./types";
import type { DatePeriodKind, DateRangeKind, DateType } from "~/graphql/supergraphTypes";

export {
  DATE_PARAMETER_LABELS,
  DYNAMIC_DATE_PICKER_OPTIONS,
  DYNAMIC_DATE_PICKER_VALUES,
  PARAMETER_OPTIONS,
  PARAMETER_OPTION_VALUES,
  getDateParameterLabel,
} from "./dateParameterCatalogue";

export const PERIOD_KIND_OPTIONS: ReadonlyArray<SelectOption<DatePeriodKind>> = [
  { value: "YEAR_TO_DATE", label: "Year to date" },
  { value: "QUARTER_TO_DATE", label: "Quarter to date" },
  { value: "MONTH_TO_DATE", label: "Month to date" },
  { value: "INCEPTION_TO_DATE", label: "Inception to date" },
  { value: "BEGINNING_YEAR", label: "Beginning year" },
  { value: "BEGINNING_QUARTER", label: "Beginning quarter" },
  { value: "BEGINNING_MONTH", label: "Beginning month" },
  { value: "TRAILING_MONTHS", label: "Trailing months" },
  { value: "CUSTOM", label: "Custom" },
];

export const DATE_TYPE_OPTIONS: ReadonlyArray<SelectOption<DateType>> = [
  { value: "GL", label: "GL date" },
  { value: "EFFECTIVE", label: "Effective date" },
];

export const CUSTOM_RANGE_KIND_OPTIONS: ReadonlyArray<SelectOption<DateRangeKind>> = [
  { value: "SINGLE", label: "Single date" },
  { value: "RANGE", label: "Date range" },
];

export const DEFAULT_DATE_PERIOD_VALUES: DatePeriodValues = {
  periodKind: "YEAR_TO_DATE",
  dateType: "GL",
  offsetMonths: 0,
  trailingMonths: null,
  customRangeKind: null,
  customStartParameter: null,
  customStartDate: null,
  customEndParameter: null,
  customEndDate: null,
};

/** Default `trailingMonths` when transitioning into `TRAILING_MONTHS`. */
export const DEFAULT_TRAILING_MONTHS = 1;
